import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import {
  Box,
  Link,
  MenuItem,
  Paper,
  Typography,
  buttonClasses,
  useMediaQuery,
} from "@mui/material";
import { IconComponent } from "src/shared/components";
import { setUserAuthentication } from "src/shared/lib/store/slices/auth";
import { useTypedDispatch } from "src/shared/lib/store/store";
import { EIconNames } from "src/shared/types/iconNames";
import { HeaderButton } from "./HeaderButton";

const StyledMenu = styled(Box)(
  ({ theme }) => `
@keyframes slide-down {
  from {
    opacity: 0;
    transform: scaleY(0);
  }

  to {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes slide-up {
  from {
    opacity: 1;
    transform: scaleY(1);
  }

  to {
    opacity: 0;
    transform: scaleY(0);
  }
}

display: flex;
position: relative;

${theme.breakpoints.down("lg")} {
  right: 0;
  left: unset;
}

& .headerMenu {
  position: absolute;
  top: 100%;
  padding-top: 16px;
  left: 0; 

  ${theme.breakpoints.down("lg")} {
   padding-top: 10px;
  }

  & > * {
    display: none;
    animation: slide-up 0.15s ease-in-out forwards;
    transform-origin: top;
  }
}

&:hover .headerMenu > * {
  display: block;
  animation: slide-down 0.15s ease-in-out forwards;
  transform-origin: top;

}

& .headerAvatar{
  border-radius: 50%;
  height: 32px;
  object-fit: cover;
  width: 32px;
}
`,
);

const menuItems = [
  {
    icon: EIconNames.PERSON_OLD,
    text: "Персональные данные",
    title: "Личные данные, табель и т.д.",
    href: "/users/personal",
  },
  {
    icon: EIconNames.PLAY_OLD,
    text: "О Webcom Group",
    title: "Компания, структура, сотрудники",
    href: "/users/company/",
  },
  {
    icon: EIconNames.SETTINGS_OLD,
    text: "Брeндбук Webcom Group",
    title: "Брeндбук Webcom Group",
    href: "/users/brandbook",
  },
  {
    icon: EIconNames.SETTINGS_OLD,
    text: "Управление системой",
    title: "Настройки, пользователи...",
    href: "/system/main/",
  },

  {
    icon: EIconNames.SIGNOUT_OLD,
    text: "Выход",
    title: "Выйти из системы",
    href: "/auth/signin",
    isHandleLogout: true,
  },
];
const StyledMenuItem = styled(MenuItem)(() => ({
  marginBottom: 12,
  padding: "6px 8px 6px 0",
  fontSize: "0.75rem",
  lineHeight: 1,
  ["&:hover"]: {
    backgroundColor: "transparent",
    opacity: 0.8,
  },
}));

export const DropdownMenu = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useTypedDispatch();
  const handlelogout = () => dispatch(setUserAuthentication(false));

  return (
    <StyledMenu flexShrink={1}>
      <HeaderButton
        disableRipple
        variant="text"
        sx={{
          ["&:hover"]: {
            [`&.${buttonClasses.root}`]: { opacity: 1 },
          },
        }}
      >
        <img
          className="headerAvatar"
          src="https://i.pravatar.cc/300"
          alt="John Doe"
          width="32"
          height="32"
        />
      </HeaderButton>
      {!isMobile && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            ml: "24px",
          }}
        >
          <Typography
            sx={{
              fontSize: "0.75rem",
              lineHeight: 1,
              fontWeight: 600,
              mb: 2,
            }}
          >
            John Doe
          </Typography>
          <Typography
            sx={{
              fontSize: "0.75rem",
              lineHeight: 1,
            }}
          >
            Отдел автоматизации, Фронт-энд программисты
          </Typography>
        </Box>
      )}
      <Paper elevation={0} component="nav" className="headerMenu">
        <Box
          sx={{
            borderRadius: "0 0 8px 8px",
            borderTop: "1px solid #b7b7b7",
            boxShadow: "0 2px 4px hsla(0, 0%, 72%, .32)",
            margin: "0 4px 4px",
            padding: "16px 48px 16px 60px",
          }}
        >
          {menuItems.map(
            ({ title, text, href, icon, isHandleLogout = false }) => (
              <StyledMenuItem key={href}>
                <Link
                  href={href}
                  title={title}
                  underline="none"
                  color="oldText.main"
                  onClick={isHandleLogout ? handlelogout : undefined}
                >
                  <Typography
                    component="span"
                    sx={{
                      lineHeight: "16px",
                      color: "#AFB6BE",
                      pr: "16px",
                    }}
                  >
                    <IconComponent fontSize={"16px"} iconname={icon} />
                  </Typography>
                  {text}
                </Link>
              </StyledMenuItem>
            ),
          )}
        </Box>
      </Paper>
    </StyledMenu>
  );
};
